import { Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { SubscriptionContext } from "../../../contexts/SubscriptionContext";
import theme from "../../../theme";
import { SubscriptionPlan } from "../../organisms/subscriptions/SubscriptionSelector";

const useStyles = makeStyles((theme) => ({
    current: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: '500',
        color: '#7e7e7e',
    },
    upgrade: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: '600',
        color: '#209488',
    },
}));

const CompaniesCountdown: React.FC<{}> = () => {
    const history = useHistory();
    const classes = useStyles();
    const { usage, subscription } = useContext(SubscriptionContext);
    const [showCounter, setShowCounter] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(0);

    useEffect(() => {
        let maxCount = 0;

        if (subscription) {
            switch (subscription.planName?.toLowerCase()) {
                case SubscriptionPlan.PowerUser:
                    maxCount = +Infinity;
                    setShowCounter(true);
                    break;
                case SubscriptionPlan.Growth_v2:
                case SubscriptionPlan.Growth_v1:
                    maxCount = 300;
                    setShowCounter(true);
                    break;
                case SubscriptionPlan.Pro_v2:
                case SubscriptionPlan.Pro_v1:
                    maxCount = 100;
                    setShowCounter(true);
                    break;
                case SubscriptionPlan.Pro_Legacy:
                    maxCount = 50;
                    setShowCounter(true);
                    break;
                case SubscriptionPlan.Free:
                default:
                    setShowCounter(false);
                    break;
            }
        }

        setLimit(maxCount);
        setCount(Number(maxCount - (usage?.dashboardsCreated || 0)));
    }, [subscription, usage?.dashboardsCreated]);

    if (!showCounter)
        return (<></>);

    return (<>
        <Stack direction="column" spacing="4px" alignItems="flex-end" justifyContent="flex-start">
            <Typography className={classes.current}
                sx={{ color: count > 3 ? theme.colors.neutral['700'] : theme.colors.warning[600] }}>
                {limit === +Infinity ? (<>
                    {`Unlimited companies`}
                </>) : (<>
                    {`${count}/${limit} companies`}
                </>)}
            </Typography>
            {limit !== +Infinity && (
                <Typography className={classes.upgrade}
                    onClick={() => history.push('/subscriptions')}
                    style={{ cursor: 'pointer' }}>
                    {`Upgrade plan`}
                </Typography>
            )}
        </Stack>
    </>);
};

export default withLDConsumer()(CompaniesCountdown);